import React from "react";
import { useTranslation } from "react-i18next";

import { useDocumentData } from "astrid-firestore/src/hooks";

import LoadingContext from "../../../ui/components/LoadingContext/LoadingContext";

import Form from "../../../forms/components/Form/Form";

import DistributionCountriesCheckboxTable from "../DistributionCountriesCheckboxTable/DistributionCountriesCheckboxTable";
import DistributionPriceForm from "../DistributionPrice/DistributionPriceForm";

export default function DistributionTargetDataForm({ name, channel, publisher }) {
	const { t } = useTranslation();

	const key = name ? `${name}.` : "";

	const [fullChannelDoc, loading] = useDocumentData(!channel.targetData && channel.ref) || [channel, false];

	const channelSupportsMetaData =
		fullChannelDoc?.acceptedDeliveryTypes?.length === 0 ||
		fullChannelDoc?.acceptedDeliveryTypes?.includes("metadata");

	return (
		<LoadingContext data={fullChannelDoc} loading={loading}>
			{fullChannelDoc?.subChannels?.length > 0 && (
				<Form.DocumentSelect
					multiple
					name={`${key}subChannels`}
					label={t("subChannels", "Sub channels")}
					options={fullChannelDoc?.subChannels?.map((subChannel) => ({
						key: subChannel.id,
						value: subChannel.id,
						text: subChannel.name,
						data: subChannel,
					}))}
				/>
			)}

			{channelSupportsMetaData && (
				<>
					{!channel.disablePrices && <DistributionPriceForm name={`${key}prices`} publisher={publisher} />}

					<DistributionCountriesCheckboxTable name={`${key}countries`} />
				</>
			)}
		</LoadingContext>
	);
}
